<script lang="ts">
	import HugeHeading from "@components/HugeHeading.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import type { ClassValue } from "svelte/elements";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import { getWorkingProcessAnchor } from "@core/schema/paths/getWorkingProcessAnchor.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const { class: customClass }: { class?: ClassValue } = $props();
	const { tenant } = getGlobalTemplateProps();
</script>

<section class={[customClass, "full-width grid-container"]}>
	<HugeHeading
		class="text-center full-width px-8"
		level={1}
		text="Na cestě k funkční logistice nl[[]] vás provedeme ve 4 fázích"
	/>
	<div class="mx-auto w-[19rem] xs:w-[25rem] sm:w-[35rem] md:w-[45rem] lg:w-[55rem]">
		<div
			class="mx-1 xs:mx-4 sm:mx-6 md:mx-8 bg-white/50 p-4 md:p-8 flex flex-col gap-4 md:gap-8 items-center rounded-3xl z-1 backdrop-blur-sm"
		>
			<p class="font-medium text-2xs md:text-base leading-[1.4] text-center">
				<Formatted
					text="Logistiku nevylepšujeme od stolu, ale společně s vámi přímo v provozu. Krok za krokem vás provedeme celým procesem, od úvodního seznámení až po vyhodnocení výsledků. "
				/>
			</p>

			<Link
				href="#{getWorkingProcessAnchor(tenant)}"
				icon="arrow"
				variant={ButtonVariant.Primary}
				class="flex gap-[1.25rem] items-end"
			>
				<Formatted text="Celý proces spolupráce" />
			</Link>
		</div>
	</div>
</section>
